import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const StyledIcon = styled.button(({ s }) => ({
  background: 'transparent',
  border: 'none',
  fontSize: 'inherit',
  padding: '0 0.5rem',
  cursor: 'pointer',
  '&:hover': {
    background: 'transparent',
  },
  ...s,
}));

const hoverStyle = {
  opacity: 0.3,
  transition: 'opacity 100ms ease-in-out',
  '&:hover': {
    opacity: 1,
    background: 'transparent',
  },
};

const Icon = ({
  hover,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  children,
  onBlur,
  ariaLabel,
  s,
  'data-test': dataTest,
}) => (
  <StyledIcon
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    onFocus={onFocus}
    onClick={onClick}
    onBlur={onBlur}
    s={{
      ...s,
      ...(hover ? hoverStyle : {}),
    }}
    aria-label={ariaLabel || 'clickable icon'}
    data-test={dataTest}
    role="button"
  >
    {children}
  </StyledIcon>
);

Icon.defaultProps = {
  hover: false,
  onClick: undefined,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  onFocus: undefined,
  onBlur: undefined,
  ariaLabel: undefined,
  s: {},
  'data-test': null,
};

Icon.propTypes = {
  hover: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  ariaLabel: PropTypes.string,
  s: PropTypes.object,
  children: PropTypes.node.isRequired,
  'data-test': PropTypes.string,
};

export default Icon;
